export class GenPersonUpdatePasswordModel{
    passwordNew: string;
    passwordOld: string;

    constructor(){}
}